import React, { useContext, useEffect, } from 'react';
import { useToggle } from '@waglabs/use-toggle';
import { ThemeContext, createGlobalStyle, } from 'styled-components';
import ReactModal from 'react-modal';
import { useMediaQuery } from 'react-responsive';
import { ModalCloseIconButton, } from './ModalCloseIconButton';
export const DEFAULT_MODAL_AUTOSHOW_TIME_MS = 10000;
export const Modal = ({ autoShow, autoShowTimeMs = DEFAULT_MODAL_AUTOSHOW_TIME_MS, children, closeIconButtonProps, isOpen: isOpenProp, noCloseIconButton, contentStyle, onOpen, onRequestClose: onRequestCloseProp, ...rest }) => {
    const { on: isOpenState, toggle: toggleIsOpenState, } = useToggle();
    const isOpenPropPassed = typeof isOpenProp !== 'undefined';
    const isOpen = isOpenPropPassed ? isOpenProp : isOpenState;
    const onRequestClose = isOpenPropPassed
        ? onRequestCloseProp
        : () => toggleIsOpenState(false);
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        if (!onOpen) {
            return;
        }
        onOpen();
    }, [isOpen]);
    useEffect(() => {
        if (!autoShow) {
            return;
        }
        if (isOpenPropPassed) {
            return;
        }
        const timeout = setTimeout(() => {
            toggleIsOpenState(true);
        }, autoShowTimeMs);
        return () => {
            clearTimeout(timeout);
        };
    }, []);
    const theme = useContext(ThemeContext);
    const isMobile = useMediaQuery({ maxWidth: theme.breakpoints[0] });
    return (React.createElement(React.Fragment, null,
        React.createElement(ReactModal, Object.assign({ closeTimeoutMS: 250, isOpen: isOpen, style: {
                content: {
                    border: 'none',
                    borderRadius: '16px',
                    boxSizing: 'border-box',
                    left: '16px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    maxHeight: 'max-content',
                    maxWidth: '480px',
                    padding: 0,
                    position: isMobile ? 'absolute' : 'relative',
                    right: '16px',
                    top: '2%',
                    ...isMobile && {
                        bottom: 'unset',
                    },
                    ...contentStyle
                },
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1300,
                },
            }, onRequestClose: onRequestClose }, rest),
            !noCloseIconButton && (React.createElement(ModalCloseIconButton, Object.assign({ onClick: onRequestClose }, closeIconButtonProps))),
            children),
        React.createElement(GlobalStyle, null)));
};
const GlobalStyle = createGlobalStyle `
  .ReactModal__Overlay {
    opacity: 0;
    transition: opacity 250ms ease-in-out;
  }

  .ReactModal__Overlay--after-open{
    opacity: 1;
  }

  .ReactModal__Overlay--before-close{
    opacity: 0;
  }
`;
